import { render } from "./NewCardIcon.vue?vue&type=template&id=1690fc02&ts=true"
import script from "./NewCardIcon.vue?vue&type=script&lang=ts"
export * from "./NewCardIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__